import boilerBusdCakeLp from "../abis/production/boilerBusd/cakeLp";
import boilerSaunaCakeLp from "../abis/production/boilerSauna/cakeLp";

const host = "https://bscscan.com/address";

export default [
  {
    name: "BOILER-BUSD",
    type: "busd",
    contractAddress: "0xA7a27776f3008D2A6A580e26a1744DB900e74580",
    minApr: 159,
    abi: boilerBusdCakeLp.abi,
    url: `${host}/0xA7a27776f3008D2A6A580e26a1744DB900e74580`,
    decimals: 18,
  },
  {
    name: "BOILER-SAUNA",
    type: "sauna",
    contractAddress: "0xf9Faf193E50AC5B216f2A939CD3Acb5Bef2b7903",
    minApr: 159,
    abi: boilerSaunaCakeLp.abi,
    url: `${host}/0xf9Faf193E50AC5B216f2A939CD3Acb5Bef2b7903`,
    decimals: 18,
  },
];
